<template>
  <div>
    <div class="merge-tag" v-bind:style="loading?'opacity:0.6':''">
      <!-- <div class="divider-custom-zalo mb-3" style="margin-top: -30px;margin-right:-20px;margin-left: -20px;" /> -->
      <div class="flex-column d-flex mb-3">
        <div class="mt-3 text-normal text-break my-2">
          <h6>Thẻ chính</h6>
          <el-select v-model="selectedTagId" placeholder="Chọn thẻ chính" 
            class="w-100 select" filterable default-first-option>
            <el-option v-for="item in tags" :key="item.id" :label="item.name"
                        :value="item.id">
              <div class="d-flex align-items-center">
                <div class="rounded-1" v-bind:style="'background-color :' + item.color"
                      style="height: 25px;width: 25px;" />
                <div class="ms-2 flex-1 text-break text-1-line-replied" style="">
                  <span v-if="item.assign === true">*</span>
                  {{ item.name }}
                </div>
              </div>
            </el-option>
          </el-select>
        </div>
        <div class="mt-3 my-2">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">Chọn thẻ cần chuyển</h6>
            <div class="search d-flex align-items-center">
              <IconV2
                slot="prefix"
                color = "grey"
                name="v2-search" />
              <el-input class="me-2" size="medium" style="width: 150px;border: none;" v-model="searchKey" @input="searchtag()" placeholder="Tìm tên thẻ" />
            </div>
          </div>
          <div class="rounded-2 d-flex align-items-center gap-1 flex-wrap p-2"
              style="overflow-y: auto; max-height: 300px; border: 1px solid #e0e4e8;max-height: 110px">
            <p class="w-100 text-center my-2" v-if="tagShows.length === 0">Không tìm thấy thẻ nào hợp lệ</p>
            <div v-else v-for="item in tagShows" :key="item.id" @click="addOrRemoveTag(item)">
              <TagCustomV2 :item="item" :selected="isSelected(item)" :is-button="true" />
            </div>
          </div>
        </div>
      </div>
      <div class=" font-size-13 text-grey text-break">
        - Hệ thống sẽ tự động gắn thẻ được chọn ở phía trên vào các liên hệ được gắn thẻ đã được chọn ở phía dưới.
        Quá trình xử lí có thể kéo dài vài phút.
      </div>
      <div class="text-grey font-size-13" >- Bạn được chuyển tối đa 10 thẻ/lần</div>
    </div>
    <div class="fw-normal d-flex justify-content-between align-items-center mt-3">
      <el-button class="text-dark fw-normal" type="grey" @click="closeDialog()" :disabled="loading" plain> Huỷ</el-button>
      <el-button class="fw-normal" type="primary" @click="mergeAndDelete()" :disabled="loading" plain>Chuyển và xóa thẻ cần chuyển</el-button>
      <el-button class="fw-normal" type="primary" @click="open()" :loading="loading">Xong</el-button>
    </div>
  </div>
</template>

<script>
import IconV2 from '../common/IconV2.vue';
import TagCustomV2 from '../common/TagCustomV2.vue';

export default {
  name: "MergeTagV2",
  components: { TagCustomV2 , IconV2 },
  props: {
    tags: Array,
    deleteTag : Function
  },
  data() {
    return {
      selectedTagId: null,
      selectedTag : null,
      selectedTags: [],
      loading: false,
      searchKey : '',
      tagShows : []
    };
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    randomInteger(min = 50000, max = 60000) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getTag(selectedTagId) {
      let tag = this.tags.find(s => s.id === selectedTagId);     
      return tag.name;
    },
    getSelectedTag(id) {
      if (this.tags && id) {
        this.selectedTag = this.tags.find(s => s.id === id);
      }
    },
    open() {
      if (this.selectedTags.length === 0) {
        return this.alertError("Bạn chưa chọn các thẻ cần chuyển");
      }
      if (this.selectedTagId === null) {
        return this.alertError("Bạn chưa chọn thẻ chính");
      }
      this.$confirm("Thao tác này sẽ tự động gắn thẻ " + this.getTag(this.selectedTagId)+" vào các liên hệ được gắn thẻ đã được chọn ở phía dưới" + " . Bạn có muốn tiếp tục ?", "Cảnh báo", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Huỷ bỏ",
        type: "warning"
      }).then(() => {
        this.save();
      }).catch(() => {

      });
    },

    mergeAndDelete() {
      if (this.selectedTags.length === 0) {
        return this.alertError("Bạn chưa chọn các thẻ cần chuyển");
      }
      if (this.selectedTagId === null) {
        return this.alertError("Bạn chưa chọn thẻ chính");
      }
      this.$confirm("Thao tác này sẽ tự động gắn thẻ " + this.getTag(this.selectedTagId)+" vào các liên hệ được gắn thẻ đã được chọn ở phía dưới và xóa các thẻ cần chuyển" + " . Bạn có muốn tiếp tục ?", "Cảnh báo", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Huỷ bỏ",
        type: "warning"
      }).then(() => {
        this.selectedTags.forEach(tag => {
          if(tag.id !== this.selectedTagId){
            this.deleteTag(tag);
          }
        });
        this.save();
      }).catch(() => {

      });
    },

    save() {
      this.loading = true;
      let request = {
        masterTagId: this.selectedTagId,
        slaveTagIds: this.selectedTags.map(s => s.id)
      };
      this.$http.post("/api/v2/tag/merge", request).then(() => {
        let duration = this.randomInteger();
        this.$message({
          message: "Quá trình xử lí có thể kéo dài vài phút. Vui lòng không thoát trang cho tới khi hoàn thành.",
          type: "warning",
          duration: duration
        });
        this.preventReload();
        setTimeout(() => {
          this.loading = false;
          this.alert("success", "Thành công");
          this.closeDialog();
        }, duration);
      });
    },

    addOrRemoveTag(item) {
      const index = this.selectedTags.indexOf(item);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        if (this.selectedTags.length > 9) return;
        this.selectedTags.push(item);
      }
    },
    isSelected(item) {
      return this.selectedTags.some(s => s.id === item.id);
    },

    preventReload() {
      window.addEventListener("beforeunload", this.handler);
    },
    removeReload() {
      window.removeEventListener("beforeunload", this.handler);
    },
    searchtag() {
      let sourceTags = this.selectedTag ? this.tags.filter(tag => tag.assign === this.selectedTag.assign && tag.id !== this.selectedTag.id) : this.tags;
      if (this.searchKey.length > 0) {
        this.tagShows = sourceTags.filter(tag =>
          tag.name.toLowerCase().includes(this.searchKey.toLowerCase())
        );
      } else {
        this.tagShows = sourceTags;
      }
    },
  },
  watch: {
    selectedTagId(newId) {
      this.getSelectedTag(newId);
      if (this.selectedTag) {
        this.tagShows = this.tags.filter(tag => tag.assign === this.selectedTag.assign && tag.id !== this.selectedTag.id);
        this.selectedTags = [];
      } else {
        this.tagShows = this.tags;
      }
    }
  },
  beforeDestroy() {
    this.removeReload();
  },
  mounted() {
    this.searchtag()
    this.handler = function(e) {
      // Cancel the event
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue = "";
    };
  }
};
</script>

<style scoped>
.merge-tag{
  border: 1px #EAECF2 solid;
  border-radius: 4px;
  padding: 12px 16px;
}
.select >>> .el-input__inner{
  border: 1px #C2DCFF solid!important;
  background: #E1EDFD52;
}
.search{
  padding: 0px 8px;
  border: 1px #DCDFE9 solid;
  border-radius: 4px;
}
</style>